export default {
  IBAN: 'SK02 8330 0000 0026 0118 5716',
  defaultPageSize: 9999,
  automaticAllocationMinInterest: 0.01,
  automaticAllocationStepRanges: [
    {
      min: 0,
      max: 2000,
      step: 50, // TODO set to 100
    },
    {
      min: 2000,
      step: 200,
    },
  ],
  defaultManualAllocationFilterValues: {
    amountMin: 0, // TODO set to 100
    amountMax: 5000,
    interestMin: 0.001,
    interestMax: 0.4,
    remainingAmountMin: 0, // TODO set to 100
    remainingAmountMax: 5000,
  },
  manualAllocationFilterSettings: {
    amountMin: 0, // TODO set to 100
    amountMax: 5000,
    amountStep: 50, // TODO set to 100
    interestMin: 0.001,
    interestMax: 0.4,
    interestStep: 0.001,
    remainingAmountMin: 0, // TODO set to 100
    remainingAmountMax: 5000,
    remainingAmountStep: 50, // TODO set to 100
  },
  manualAllocationAmountDivisibleBy: 10, // TODO set to 100
  calculatorMonthsMin: 6,
  calculatorMonthsMax: 24,
  calculatorMonthsStep: 1,
  monthsRange: [
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60
  ],
  captcha_site_key: "6LcTFgIaAAAAAD07-z4pXzCYgZbRz5PpEffCamv-",
};



// WEBPACK FOOTER //
// ./src/config.js